export const removeAccents = (text) => {

    if(text === null || text === undefined) return text;

    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
